module.exports = __webpack_public_path__ + "img/gszz3@2x.87b5fc5b.png";